module.exports = __webpack_public_path__ + "img/blockallow.21ed04a2.gif";